/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

type MaybeEnvContainer = {
	env?: Record<string, unknown>
}

const FALLBACK_DOMAINS = ['wp_donate_data', 'wp_react_plugin_data'] as const

function findEnv(): Record<string, unknown> | undefined {
	// 1) Try known domains first
	for (const domain of FALLBACK_DOMAINS) {
		const candidate = (window as any)?.[domain] as MaybeEnvContainer | undefined
		if (candidate?.env) return candidate.env
	}

	// 2) Heuristic: find any `*_data` that contains `.env.API_URL`
	try {
		for (const key of Object.keys(window as any)) {
			if (!key.endsWith('_data')) continue
			const candidate = (window as any)[key] as MaybeEnvContainer | undefined
			const env = candidate?.env
			if (env && (env as any).API_URL) return env
		}
	} catch {
		// ignore
	}

	return undefined
}

const env = findEnv()

export const SITE_URL = env?.SITE_URL
export const API_URL = env?.API_URL || '/wp-json'
export const CURRENT_USER_ID = env?.CURRENT_USER_ID || 0
export const POST_ID = env?.POST_ID || 0
export const PERMALINK = env?.PERMALINK || ''
export const AJAX_URL = env?.AJAX_URL || '/wp-admin/admin-ajax.php'
export const APP_NAME = env?.APP_NAME || 'Wp React Plugin'
export const KEBAB = env?.KEBAB || 'wp-react-plugin'
export const SNAKE = env?.SNAKE || 'wp_react_plugin'
export const NONCE = env?.NONCE || ''
export const APP1_SELECTOR = env?.APP1_SELECTOR || 'wp_react_plugin'
export const APP2_SELECTOR = env?.APP2_SELECTOR || 'wp_react_plugin_metabox'
export const ELEMENTOR_ENABLED = env?.ELEMENTOR_ENABLED || false

